import { GlobalState } from "little-state-machine";

const initialState = () : GlobalState => ({
  username: undefined
});

export { initialState };
